/**
 * Image Search Agent - Variable Definitions
 *
 * Keywords AI Keys:
 * - IMAGE_SEARCH_INTRO
 * - IMAGE_SEARCH_TOOLS_PREAMBLE
 * - IMAGE_SEARCH_TOOLS_POSTAMBLE
 * - IMAGE_SEARCH_SUGGESTIONS
 * - IMAGE_SEARCH_CONTEXT_NOTE
 * - IMAGE_SEARCH_EVALUATION
 */
export const IMAGE_SEARCH_VARIABLES = {
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};
export const IMAGE_SEARCH_PROMPT_KEYS = {
    intro: 'IMAGE_SEARCH_INTRO',
    toolsPreamble: 'IMAGE_SEARCH_TOOLS_PREAMBLE',
    toolsPostamble: 'IMAGE_SEARCH_TOOLS_POSTAMBLE',
    suggestions: 'IMAGE_SEARCH_SUGGESTIONS',
    contextNote: 'IMAGE_SEARCH_CONTEXT_NOTE',
    evaluation: 'IMAGE_SEARCH_EVALUATION',
};
export const IMAGE_SEARCH_PROMPT_CONFIG = {
    agentName: 'imageSearch',
    sections: {
        intro: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: IMAGE_SEARCH_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: IMAGE_SEARCH_VARIABLES,
};
